export default {
      id: "common__envelope-usage",
      viewBox: "0 0 17 13",
      url: __webpack_public_path__ + "img/icons.svg#common__envelope",
      toString: function () {
        return this.url;
      }
    }